import styled, { css } from "styled-components";

export const Container = styled.div`
  height: 100%;
  position: relative;
`;

export const Content = styled.div`
  ${({ theme }) => css`
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
    margin-top: 1rem;

    @media (min-width: 768px) {
      max-width: 460px;
    }
  `}
`;

export const TotalCollaborator = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${theme.colors.ultraLightGray};
    padding: 1rem 1rem 1.5rem;

    p {
      line-height: 1;
      margin: 0;
      text-transform: uppercase;
      color: ${theme.colors.primary};
      font-size: 0.875rem;
    }

    span {
      font-size: 0.875rem;
      background-color: ${theme.colors.primary};
      color: ${theme.colors.white};
      text-align: center;
      height: 18px;
      width: 26px;
      border-radius: 16px;
    }

    @media (min-width: 768px) {
      span {
        font-size: 1rem;
        height: 24px;
        width: 26px;
      }
    }
  `}
`;

export const List = styled.div`
  ${({ theme }) => css`
    padding: 0 1rem 1rem;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background-color: ${theme.colors.white};
    margin-top: -0.5rem;
    box-shadow: 0 -4px 2px -3px rgba(0, 0, 0, 0.1);

    @media (min-width: 768px) {
      height: calc(100vh - 320px);
      overflow-y: auto;
    }
  `}
`;

export const SectionCollaborators = styled.div`
  ${({ theme }) => css`
    div + div {
      margin-top: 1rem;
    }

    div:last-child {
      border: none;
    }

    h3 {
      font-size: 0.875rem;
      color: ${theme.colors.gray};
      padding: 1rem 0;
    }
  `}
`;

export const ContentButton = styled.div`
  padding: 0 0.5rem 1rem;
`;
